import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaPlane, 
  FaList, 
  FaBars, 
  FaTimes, 
  FaUser, 
  FaBell,
  FaSearch,
  FaGlobe
} from 'react-icons/fa';
import ThemeDropdown from './ThemeDropdown';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Flight Booking', href: '/booking', icon: FaPlane },
    { name: 'Booking History', href: '/bookings', icon: FaList },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary-50 to-primary-50">
      {/* Header */}
      <header className="bg-white shadow-business border-b border-secondary-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden p-2 rounded-md text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100"
              >
                {sidebarOpen ? <FaTimes /> : <FaBars />}
              </button>
              <div className="flex items-center ml-4 lg:ml-0">
                {/* <div className="bg-gradient-to-r from-primary-600 to-primary-700 p-2 rounded-lg">
                  <FaPlane className="h-6 w-6 text-white" />
                </div> */}
                <div className="ml-3">
                  <h1 className="text-xl font-display font-bold text-secondary-900">
                    BCD Travel
                  </h1>
                </div>
              </div>
            </div>

            {/* Search Bar */}
            <div className="hidden md:flex flex-1 max-w-lg mx-8">
              <div className="relative w-full">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400 h-4 w-4" />
                <input
                  type="text"
                  placeholder="Search flights, customers, bookings..."
                  className="w-full pl-10 pr-4 py-2 border border-secondary-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none"
                />
              </div>
            </div>

            {/* Right side */}
            <div className="flex items-center space-x-4">
              <button className="p-2 text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100 rounded-lg">
                <FaBell className="h-5 w-5" />
              </button>
              <button className="p-2 text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100 rounded-lg">
                <FaGlobe className="h-5 w-5" />
              </button>
              <div className="flex items-center space-x-2 bg-secondary-100 rounded-lg px-3 py-2">
                <div className="h-8 w-8 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full flex items-center justify-center">
                  <FaUser className="h-4 w-4 text-white" />
                </div>
                <div className="hidden sm:block">
                  <p className="text-sm font-medium text-secondary-900">Admin User</p>
                  <p className="text-xs text-secondary-500">Administrator</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className={`${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white shadow-business border-r border-secondary-200 transition-transform duration-300 ease-in-out lg:transition-none h-[92vh]`}>
          <div className="flex flex-col h-full pt-20 lg:pt-6">
            <nav className="flex-1 px-4 space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`${
                      isActive(item.href)
                        ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-600'
                        : 'text-secondary-600 hover:bg-secondary-50 hover:text-secondary-900'
                    } group flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors`}
                    onClick={() => setSidebarOpen(false)}
                  >
                    <Icon className={`${
                      isActive(item.href) ? 'text-primary-600' : 'text-secondary-400 group-hover:text-secondary-600'
                    } mr-3 h-5 w-5`} />
                    {item.name}
                  </Link>
                );
              })}
              <ThemeDropdown />
            </nav>
            
            {/* Footer */}
            <div className="p-4 border-t border-secondary-200">
              <div className="bg-gradient-to-r from-primary-50 to-primary-100 rounded-lg p-4">
                <h3 className="text-sm font-semibold text-primary-900 mb-1">Need Help?</h3>
                <p className="text-xs text-primary-700 mb-2">Contact our support team</p>
                <button className="text-xs bg-primary-600 text-white px-3 py-1 rounded-md hover:bg-primary-700 transition-colors">
                  Get Support
                </button>
              </div>
            </div>
          </div>
        </aside>

        {/* Overlay for mobile */}
        {sidebarOpen && (
          <div 
            className="lg:hidden fixed inset-0 z-40 bg-black bg-opacity-50"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Main content */}
        <main className="flex-1 lg:ml-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;